var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-1" },
    [
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c(
            "section",
            { staticClass: "grid-accessory" },
            [
              _c("cart-banner", {
                staticClass: "mb-1",
                attrs: {
                  "cart-link": _vm.cartUrl,
                  "number-of-items": _vm.accessoriesCount,
                  "back-link": _vm.accessoryDetails.cartBannerDTO.backlinkLabel,
                  "cart-enabled": _vm.cartEnabled,
                  "is-new-selector-activated":
                    _vm.accessoryDetails.newSelectorActivated,
                  "back-url": _vm.backUrl,
                },
              }),
              _vm._v(" "),
              _c("h1", { staticClass: "item-title mb-1" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.accessoryDetails.name) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _vm.displayRatings
                ? _c("ob1-rating", {
                    staticClass: "item-summary mb-1",
                    attrs: {
                      average: _vm.currentAccessory.reviewsStats.average,
                      text:
                        "(" +
                        _vm.currentAccessory.reviewsStats.count +
                        " avis)",
                      "rating-results-height": 2.375,
                      link: "#anchor-reviews",
                    },
                    on: {
                      "ob1-rating-link": function ($event) {
                        $event.preventDefault()
                        return _vm.scrollToPageMenuAnchor("anchor-reviews")
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "item-img" },
                [
                  _c("ob1-carrousel", {
                    key: "accessory-gallery-" + _vm.currentAccessory.seoId,
                    attrs: {
                      id: "accessory-gallery",
                      images: _vm.currentAccessory.galleries,
                      "is-product-sheet": true,
                      "is-device-product-sheet": true,
                      "with-zoom": true,
                      "with-thumbnails": true,
                    },
                  }),
                  _vm._v(" "),
                  _vm.currentAccessory.asilage
                    ? _c("ob1-separateur", { staticClass: "my-1" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentAccessory.asilage
                    ? _c("asilage", {
                        staticClass: "mb-1 mb-lg-auto",
                        attrs: {
                          title: _vm.currentAccessory.asilage.title,
                          banner: _vm.currentAccessory.asilage.banner,
                          condition: _vm.currentAccessory.asilage.condition,
                          "form-url": _vm.currentAccessory.asilage.formUrl,
                          image: _vm.currentAccessory.asilage.image,
                          "condition-label":
                            _vm.currentAccessory.asilage.conditionLabel,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "item-chips-capas" },
                [
                  _vm.showDeclinaisonName ? _c("ob1-separateur") : _vm._e(),
                  _vm._v(" "),
                  _vm.showDeclinaisonName
                    ? _c("h2", {
                        staticClass: "fw-bold no-signature standard my-1",
                        domProps: { innerHTML: _vm._s(_vm.subtitle) },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.allVersions.length > 1 && _vm.numberOfColors > 0
                    ? _c("ob1-pastilles-de-couleurs", {
                        ref: "pastilles-de-couleurs",
                        staticClass: "mb-1",
                        class: !_vm.showDeclinaisonName ? "mt-2" : null,
                        attrs: {
                          id: "colors",
                          "default-color": _vm.currentAccessory.color
                            ? _vm.currentAccessory.color.code
                            : null,
                          colors: _vm.allColors,
                        },
                        on: {
                          "ob1-pastilles-de-couleurs-click":
                            _vm.changeSelectedColor,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.numberOfCapacities > 0
                    ? _c(
                        "fieldset",
                        {
                          class: _vm.numberOfColors > 0 ? "mb-1" : "mt-1 mb-1",
                        },
                        [
                          _c("legend", { staticClass: "visually-hidden" }, [
                            _vm._v(
                              "\n                        Capacités disponibles\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.allCapacities, function (capacity, index) {
                            return _c("ob1-chips", {
                              key: "capacity-" + index,
                              attrs: {
                                id: "capacity-" + index,
                                "is-choice-version": true,
                                label: capacity.capacity,
                                "is-disabled": !capacity.inStock,
                                "is-checked": capacity.checked,
                                "disable-uncheck": true,
                              },
                              on: {
                                "ob1-chips-click": function ($event) {
                                  return _vm.changeSelectedCapacity(
                                    $event,
                                    capacity.capacity
                                  )
                                },
                              },
                            })
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.numberOfLengths > 0
                    ? _c(
                        "fieldset",
                        {
                          class:
                            _vm.numberOfCapacities > 0 || _vm.numberOfColors > 0
                              ? "mb-1"
                              : "mt-1 mb-1",
                        },
                        [
                          _c("legend", { staticClass: "visually-hidden" }, [
                            _vm._v(
                              "\n                        Longueurs disponibles\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.allLengths, function (length, index) {
                            return _c("ob1-chips", {
                              key: "length-" + index,
                              attrs: {
                                id: "length-" + index,
                                "is-choice-version": true,
                                label: length.length,
                                "is-disabled": !length.inStock,
                                "is-checked": length.checked,
                                "disable-uncheck": true,
                              },
                              on: {
                                "ob1-chips-click": function ($event) {
                                  return _vm.changeSelectedLength(
                                    $event,
                                    length.length
                                  )
                                },
                              },
                            })
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "item-accessory-info" }, [
                _vm.currentAccessory.accessoryPrice
                  ? _c(
                      "div",
                      { staticClass: "item-price me-xl-2 me-lg-1" },
                      [
                        _c("accessory-price", {
                          attrs: {
                            "accessory-price":
                              _vm.currentAccessory.accessoryPrice,
                            "funding-details":
                              _vm.accessoryDetails.fundingDetails,
                            "promo-label": _vm.promoLabel,
                            "promo-end-date": _vm.promoEndDate,
                            "show-guarantee-legal-mentions":
                              _vm.accessoryDetails.showGuaranteeLegalMentions,
                            "guarantee-legal-mentions-label":
                              _vm.accessoryDetails.guaranteeLegalMentionsLabel,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "item-refund" },
                  [
                    _vm.currentAccessory.compactPromoValuesDto &&
                    _vm.currentAccessory.compactPromoValuesDto.odrData.length >
                      0
                      ? _c("refunds", {
                          attrs: {
                            odrs: _vm.currentAccessory.compactPromoValuesDto
                              .odrData,
                            "device-seo-id": _vm.currentAccessory.seoId,
                            "refund-messages":
                              _vm.accessoryDetails.refundMessages,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "item-cta" },
                  [
                    _vm.currentAccessory.inStock
                      ? _c(
                          "div",
                          [
                            _c("accessory-cta", {
                              attrs: {
                                accessory: _vm.accessoryDetails,
                                "is-loading": _vm.isLoading,
                                "is-add-button-enabled": _vm.isAddButtonEnabled,
                                "cart-url": _vm.cartUrl,
                              },
                              on: {
                                "accessory-cta-click":
                                  _vm.onAddAccessoryButtonClick,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm.currentAccessory.stockAlertDto
                      ? _c("ob1-message-alerte", {
                          staticClass: "item-stock-warning mt-lg-1 mt-2",
                          attrs: {
                            "is-simple-alerte": false,
                            title: _vm.currentAccessory.stockAlertDto.title,
                            text: _vm.currentAccessory.stockAlertDto.message,
                            type: "warning",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row align-items-center" },
            [
              _vm.accessoryDetails.dasDTO
                ? _c("das", {
                    staticClass: "col-12 col-md-auto mt-2 mt-md-0 me-md-2",
                    attrs: {
                      head: _vm.accessoryDetails.dasDTO.head,
                      trunk: _vm.accessoryDetails.dasDTO.trunk,
                      member: _vm.accessoryDetails.dasDTO.member,
                      prefix: _vm.accessoryDetails.dasDTO.prefix,
                      "popin-title": _vm.accessoryDetails.dasDTO.popinTitle,
                      "popin-text":
                        _vm.accessoryDetails.dasDTO.popinDescription,
                      "is-sosh-shop": _vm.isSoshShop,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.accessoryDetails.chargerIncluded
                ? _c(
                    "div",
                    { staticClass: "col-12 col-md-auto px-md-0 mt-2 mt-md-0" },
                    [
                      _c("div", { staticClass: "d-flex align-items-center" }, [
                        _c("div", {
                          staticClass:
                            "icon icon-charger-availability charger-icon-size text-gray4",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("strong", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.accessoryDetails.chargerIncludedMessage
                            ),
                          },
                        }),
                      ]),
                    ]
                  )
                : _vm.accessoryDetails.chargerCompatibleInfosDTO
                ? _c(
                    "div",
                    { staticClass: "col-12 col-md-auto px-md-0 mt-2 mt-md-0" },
                    [
                      _c("ChargerInfos", {
                        attrs: {
                          "charger-infos":
                            _vm.accessoryDetails.chargerCompatibleInfosDTO,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "item-desc" },
            [
              _vm.shouldDisplayPXFMention
                ? _c(
                    "section",
                    [
                      _c("ob1-separateur", { staticClass: "my-2 mb-xl-3" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("financing-mentions", {
                              attrs: {
                                "financing-mentions": _vm.financingMentions,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("ob1-separateur", { staticClass: "mt-2 mb-1" }),
              _vm._v(" "),
              _vm.accessoryDetails.descriptionTitle
                ? _c("p", { staticClass: "lead text-mw mb-0" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.accessoryDetails.descriptionTitle)),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.accessoryDetails.description
                ? _c("p", {
                    staticClass: "text-mw",
                    domProps: {
                      innerHTML: _vm._s(_vm.accessoryDetails.description),
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.accessoryDetails.pageMenuDTO
            ? _c("ob1-page-menu", {
                staticClass: "sticky bg-white",
                attrs: {
                  id: "accessory-details-page-menu",
                  tabs: _vm.accessoryDetails.pageMenuDTO.tabs,
                },
                on: { "ob1-page-menu-click": _vm.scrollToPageMenuAnchor },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.accessoryDetails.pushZigZagDTO
            ? _c(
                "section",
                [
                  _c("div", {
                    staticClass: "pt-2 mb-xl-3",
                    attrs: { id: "anchor-zig-zag" },
                  }),
                  _vm._v(" "),
                  _c("h2", [
                    _vm._v(_vm._s(_vm.accessoryDetails.essentialTitle)),
                  ]),
                  _vm._v(" "),
                  _c("push-zig-zag", {
                    attrs: { zigzag: _vm.accessoryDetails.pushZigZagDTO },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.accessoryDetails.accessoryTechnicalFeaturesDTO
            ? _c(
                "section",
                [
                  _c("ob1-separateur", {
                    staticClass: "my-2 mb-xl-3",
                    attrs: { id: "anchor-technical-sheet" },
                  }),
                  _vm._v(" "),
                  _c("accessory-technical-features", {
                    attrs: {
                      "accessory-features":
                        _vm.accessoryDetails.accessoryTechnicalFeaturesDTO,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.accessoryDetails.showGuaranteeLegalMentions
            ? _c(
                "section",
                [
                  _c("ob1-separateur", {
                    staticClass: "my-2 mb-xl-3",
                    attrs: { id: "anchor-guarantee-legal-mentions" },
                  }),
                  _vm._v(" "),
                  _c("guarantee-legal-mentions", {
                    attrs: { "legal-mentions": _vm.deviceLegalMentions },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.displayRatings
            ? [
                _c(
                  "section",
                  { staticClass: "mb-2 mb-md-3" },
                  [
                    _c("ob1-separateur", {
                      staticClass: "my-2",
                      attrs: { id: "anchor-reviews" },
                    }),
                    _vm._v(" "),
                    _c("header-signature", {
                      attrs: {
                        text: _vm.accessoryDetails.reviewsMessages.title,
                      },
                    }),
                    _vm._v(" "),
                    _c("device-average-rating-reviews", {
                      attrs: {
                        "average-ratings":
                          _vm.deviceAverageRatingReviews.averageRatings,
                        "reviews-stats-average":
                          _vm.currentAccessory.reviewsStats.average,
                        "reviews-stats-text":
                          "(" +
                          _vm.currentAccessory.reviewsStats.count +
                          " avis)",
                        loading: _vm.deviceAverageRatingReviews.loading,
                        "reviews-messages":
                          _vm.accessoryDetails.reviewsMessages,
                      },
                    }),
                    _vm._v(" "),
                    _c("device-filter-and-details-reviews", {
                      attrs: {
                        "device-details-reviews": _vm.deviceDetailsReviews,
                        "device-filter-reviews": _vm.deviceFilterReviews,
                        "reviews-messages":
                          _vm.accessoryDetails.reviewsMessages,
                        "ratings-filter-checkboxes":
                          _vm.ratingsFilterCheckboxes,
                      },
                      on: {
                        "update-ratings-filter-handler":
                          _vm.updateRatingsFilterHandler,
                        "more-device-reviews": _vm.getMoreDeviceReviews,
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-1" },
            [
              _vm.accessoryDetails.environmentalQualityDTO
                ? _c("ob1-liens", {
                    staticClass: "mw-100 py-0",
                    attrs: {
                      href: _vm.accessoryDetails.environmentalQualityDTO.url,
                      text: _vm.accessoryDetails.environmentalQualityDTO
                        .linkLabel,
                      "with-arrow": true,
                      "is-mini": true,
                      target: "'_blank'",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm.currentAccessory.accessoryPrice.price.paymentInfoLabel &&
      _vm.currentAccessory.accessoryPrice.price.paymentInfoLabel.type === "CB4X"
        ? _c("div", { staticClass: "bg-gray2 mt-1 pt-1 pb-1" }, [
            _c(
              "div",
              { staticClass: "container-fluid" },
              [
                _c("legal-mentions4x-cb", {
                  attrs: {
                    label: _vm.accessoryDetails.legalMentions.cb4xMention,
                    "popin4x-cb": _vm.accessoryDetails.legalMentions.popin4xCb,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("section", [
        _c(
          "div",
          { staticClass: "container-fluid" },
          [_c("ob1-breadcrumb", { attrs: { items: _vm.breadcrumbItems } })],
          1
        ),
      ]),
      _vm._v(" "),
      _c("ob1-snack-bar", {
        ref: "snackbar",
        attrs: {
          id: "snackbar",
          icon: "icon-error-severe",
          label: _vm.errorMessage,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }